export const name = 'tpaCommons' as const
export const TpaHandlersManagerSymbol = Symbol('TpaHandlersManager')
export const MasterPageTpaPropsCacheSymbol = Symbol('TpaPropsCache')
export const TpaContextMappingSymbol = Symbol('TpaContextMapping')
export const TpaSrcBuilderSymbol = Symbol('TpaSrcBuilder')
export const TpaSectionSymbol = Symbol('TpaSection')
